import React from 'react';
import BasicModal from './BasicModal';
import TimeAgo from 'react-timeago';
import '../App.css';

const baseUrl = window.location.protocol + '//' + window.location.host;

export default class InviteModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {showModal: true};
  }

  deleteInvite(inviteId) {
    console.log('User clicked delete on inviteId: ' + inviteId);
    let that = this;
    let invites = this._modal.state.invites;
    fetch(`/api/v1/invites/${inviteId}`, {method: 'DELETE'}, function(err, data) {
      if (data) {
        console.log('Got data back from delete of invite: ' + JSON.stringify(data.body));
        // Now delete the row from the UI.
        let found = false;
        for (let i = 0; i < invites.length; i++) {
          if (invites[i]._id['$oid'] === inviteId) {
            console.log('Deleting invite from view: ' + inviteId);
            invites.splice(i, 1);
            found = true;
            break;
          }
        }
        if (found) {
          that.updateInviteList(invites);
        }
      } else if (err) {
        console.log('Error deleting invite: ' + err);
      }
    });
  }

  updateInviteList(invites) {
    let inviteElements = [];
    for (let i = 0; i < invites.length; i++) {
      let rowClass = i % 2  ? 'row' : 'rowGrey';
      let deleteButton = '';
      if (invites[i].invite_state === 'pending') {
        deleteButton = <div className='rowField' style={{width: '48px'}}>
                         <button className='deleteRowButton' key={'delete_' + invites[i]._id['$oid']}
                                 onClick={this.deleteInvite.bind(this, invites[i]._id['$oid'])}>
                             Excluir
                         </button>
                       </div>;
      }
      let inviteStateClass = 'rowField';
      if (invites[i].invite_state === 'pending') {
        inviteStateClass = 'rowFieldItalic';
      }
      let inviteRow = <div key={invites[i]._id['$oid']} className={rowClass} style={{'textAlign': 'left'}} >
                        <div className='rowField' style={{textAlign: 'left', width: '170px', overflow: 'hidden'}}>{invites[i].email}</div>
                        <div className='rowField' style={{width: '78px', fontSize: '11px'}}><TimeAgo date={invites[i].created_at} /></div>
                        <div className={inviteStateClass} style={{width: '46px'}}>{invites[i].invite_state}</div>
                        {deleteButton}
                      </div>
      inviteElements.push(inviteRow);
    }
    let modalBottom = <div className='inviteList'>{inviteElements}</div>;
    this._modal.setState({
      invites: invites,
      modalBottom: modalBottom,
    });
  }


  getInviteList() {
    let that = this;
    // let invites = [];
    // let inviteElements = [];
    fetch(`${baseUrl}/api/v1/users/${this.props.user._id['$oid']}/invites`, function(err, data)  {
      if (data) {
        let parsedBody = JSON.parse(data.body);
        console.log('Parsed body invites length: ' + parsedBody['invites'].length);
        console.log('Parsed body invites: ' + JSON.stringify(parsedBody['invites']));
        if (parsedBody && parsedBody['invites']) {
          that.updateInviteList(parsedBody['invites']);
        }
      } else {
        console.log('Got nothing: err is: ' + err);
      }
    });
  }


  componentWillMount() {
    // Fetch invite list and status.. 
    this.getInviteList();
  }


  submitInvite(e) {
    e.preventDefault();
    console.log('Submit invite called. The inviteEmail is now: ' + this._modal.state.inviteEmail);
    if (!this._modal.state.inviteEmail) {
      return;
    }
    // TODO - Send the invitation! Handle error codes that may indicate that we have reached our
    //        limit, etc.
    let that = this;
    let invites = this._modal.state.invites;
    fetch(`/api/v1/invites`, {
      method: 'POST',
      form: {email: that._modal.state.inviteEmail},
    }, function(err, data) {
      if (err) {
        console.log('Error creating invite: ' + err);
      } else {
        // Get the invite object and push it into the 
        let parsedBody = JSON.parse(data.body);
        if (parsedBody['InviteError']) {
          alert(parsedBody['InviteError']);
        } else if (parsedBody['OperationError']) {
          alert(parsedBody['OperationError']);
        } else if (parsedBody['invites']) {
          invites.push(parsedBody['invites']);
          that.updateInviteList(invites);
        } else {
          alert('Erro não reconhecido');
        }
      }
    });
  }


  hideModal() {
    this.props.app.setState({showInviteModal: false});
  }


  setEmail(event) {
    let newValue = event.target.value;
    this._modal.setState({inviteEmail: newValue, modalTop: this.generateModalTop(newValue)});
  }


  generateModalTop(inputValue) {
    return <div className='inviteInput'>
             <input className='mediumInput' placeholder='Email' type='text' 
                    onChange={(e) => this.setEmail(e)} value={inputValue} />
             <button className='submitInviteButton' onClick={(e) => this.submitInvite(e)}>Invite</button>
             <br /><p />
           </div>;
  }


  render() {
    if (this.state.showModal) {
      let that = this;
      let value = '';
      if (that._modal && that._modal.state) {
        value = that._modal.state.inviteEmail;
      }
      let modalTop = this.generateModalTop(value);
      return(
        <BasicModal app={this.props.app} modalTop={modalTop} modalBottom='' ref={(ref) => this._modal = ref} />
      );
    } else {
      return ('');
    }
  }
}

